import { Layout } from '@components/Layout';
import { PageHeader } from '@components/PageHeader';
import Header from '@components/_OldDesign/header';
import Link from 'next/link';
import { ReactElement } from 'react';
import { NextPageWithLayout } from './_app';

const DataSubjectRightRequestPage: NextPageWithLayout = () => {
  return (
    <>
      <Header content={{
          title: 'Data Subject Rights Request - คำขอใช้สิทธิของเจ้าของข้อมูล CODIUM',
          content: 'ส่งคำขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลกับ CODIUM เรามุ่งมั่นในการปกป้องข้อมูลของคุณและปฏิบัติตามกฎหมายความเป็นส่วนตัวอย่างเคร่งครัด',
          image: null,
        }} />
      <PageHeader
        topic="คำขอใช้สิทธิ ของเจ้าของข้อมูลส่วนบุคคล"
        detail="ช่องทางการยื่นคำขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล (Data Subject Rights Request)"
        backgroundImage="/images/data-subject-right-request/data-subject-right-request-page-header.png"
      />

      <div
        className="relative w-screen h-fit py-16"
        style={{ minHeight: '50vh' }}
      >
        <section className="Container flex flex-col text-p1Regular text-gray-600">
          <p>
            ท่านในฐานะเจ้าของข้อมูลส่วนบุคคลมีสิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ. 2562 กำหนดไว้ (โปรดศึกษาเพิ่มเติมได้ที่{' '}
            <Link href="/privacy-policy">
              <a className="cursor-pointer text-lightBlue underline hover:text-lightBlue-500">
                ประกาศความเป็นส่วนตัวของบริษัทฯ
              </a>
            </Link>{' '}
            ) หากท่านต้องการใช้สิทธิ์ ท่านสามารถส่งคำร้องมาที่อีเมล{' '}
            <a
              href="mailto:contact@codium.co"
              className="cursor-pointer text-lightBlue underline hover:text-lightBlue-500"
            >
              contact@codium.co
            </a>{' '}
            เมื่อเราได้รับคำร้องแล้วเราจะดำเนินการตามคำขอ ของท่านภายใน 30
            วันนับแต่วันทีได้รับคำร้องขอ
          </p>
          <p className="mt-10">อัปเดตล่าสุด 24 กันยายน 2569</p>
        </section>
      </div>
    </>
  );
};

DataSubjectRightRequestPage.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default DataSubjectRightRequestPage;
